<template>
  <b-modal id="job-title" ref="modal" size="lg" title="Add" @show="resetModal" @hidden="resetModal"
           @ok="handleOk">
    <b-form @submit.stop.prevent="onSubmit" >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <div class="form-row">
                <label class="col-md-3">Job Title</label>
                <div class="col-md-8 mb-3">
                  <v-select :options="options.job_title" v-model="input_data.job_title"></v-select>
                </div>
              </div>

              <div class="form-row">
                <label class="col-md-3">Date of Issue</label>
                <div class="col-md-8 mb-3">
                  <flat-pickr :config="config" v-model="input_data.issue_date"></flat-pickr>
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Expiration Date</label>
                <div class="col-md-8 mb-3">
                  <flat-pickr :config="config" v-model="input_data.expiration_date"></flat-pickr>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import {BForm, BModal} from "bootstrap-vue"

import flatPickr from 'vue-flatpickr-component'
import vSelect  from "vue-select"
export default {
  name: "FunctionalPositionInput",
  components:{
    BForm,
    flatPickr,
    BModal,
    vSelect
  },
  data(){
    return {
      input_data:{
        job_title:"",
        issue_date:"",
        expiration_date:""
      },
      options:{
        job_title:[]
      },
      config:{
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
        locale: {
          rangeSeparator: ' - '
        },
      },
    }
  },
  methods:{
    onSubmit(){
      this.$parent.getData()
    },
    handleOk(bvModalEvt){
      bvModalEvt.preventDefault()
    },
    resetModal(){
      this.items = []
    },
  },
}
</script>